/**
 * Menu column 4 in the footer
 */

// Import statements
import React from "react"
import {graphql, useStaticQuery} from "gatsby";
import NavPills from "../common/nav-pills";

/**
 * Define the FooterColumnFourMenu component
 * @param menu
 * @returns {JSX.Element}
 * @constructor
 */
const FooterColumnFourMenu = ({menu}) => {

    // query col_4 menu
    const col_4_menu_data = useStaticQuery(
        graphql`
          query {
            wpMenu(locations: {eq: FOOTER_4_NAVIGATION}) {
              id
              name
              menuItems {
                nodes {
                  parentId
                  label
                  path
                  childItems {
                    nodes {
                      path
                      label
                    }
                  }
                }
              }
            }
          }
        `
    );

    // get parent items of the col_4 menu
    const col_4_menu = col_4_menu_data.wpMenu.menuItems.nodes
        ? col_4_menu_data.wpMenu.menuItems.nodes.filter(menuItem => menuItem.parentId === null)
        : null

    // return the col_4 menu
    return (
        <section className="col-md-2 col-sm-4 col-xs-6">
            <h3>{col_4_menu_data.wpMenu.name}</h3>
            <NavPills menu={col_4_menu} ul_class="nav nav-pills flex-column"/>
        </section>

    )
}

/**
 * Export the menu
 */
export default FooterColumnFourMenu